import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: () => `${appName}`,
    resolve: (name) => {
        const pages = import.meta.glob([
            './Pages/**/*.tsx',
            '../../app-modules/*/resources/js/Pages/**/*.tsx',
        ]);

        // Extract the page name from the path.
        // e.g. Workflow::Workflow/Index -> Index
        //      Auth::Login -> Login
        const page = name.includes('/')
            ? name.split('/').pop()
            : name.split('::').pop();

        const regex = /([^:]+)::(.+)/;
        const matches = regex.exec(name);

        if (matches && matches.length > 2) {
            const module = matches[1].toLowerCase();
            const pagePath = matches[2];

            return pages[
                `../../app-modules/${module}/resources/js/Pages/${pagePath}/${page}.tsx`
            ]();
        }

        return pages[`./Pages/${name}/${page}.tsx`]();
    },
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});
